export function needMapperListResponse(json, headers) {
  let data = json.map((resource) => ({
    ...resource,
    id: resource.objectId,
    needId: resource.objectId,
    type: 'need',
    description: resource.title,
    url: '/need/' + resource.objectId,
    // content: { label: resource.title, needId: resource.objectId, id: resource.objectId, description: resource.title },
     content: { label: 'The Rolling Stones', description: 'English rock band formed in London in 1962'  } 
  }))

  return {
    data,
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateNeedId(json) {
  return {
    data: { ...json, id: json.objectId },
  };
}

export function fixCreateNeedId(params, json) {
  return {
    data: { ...params.data, id: json.result.objectId },
  };
}

export function needMapperGetOneResponse(json) {
  return {
    data: { ...json.result, id: json.result.objectId, needId: json.result.objectId },
  };
}